class LocalStorageServiceMock extends Storage {
  store: Record<string, string>;

  constructor() {
    super();

    this.store = {
    };
  }

  clear(): void {
    this.store = {
    };
  }

  getItem(key: string): null | string {
    return this.store[key] || null;
  }

  setItem(key: string, value: number | Record<string, unknown> | string): void {
    this.store[key] = value.toString();
  }

  removeItem(key: string): void {
    delete this.store[key];
  }
}

export default LocalStorageServiceMock;
